export class MediaData {
    medias: {
        group?: string;
        id: number;
    }[] = [];
}
